export const getBaseApiUrl = () => {
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
        return "https://localhost:7124/api/"
    }
    else {
        return "/api/"
    }
}
